import {acceptHMRUpdate, defineStore} from "pinia";
import {useCurrentFiltersStore} from "./currentFilters";
import moment from "moment";

// Store obsługujący stan i logikę widoku bieżących pomiarów pojazdów
export const useCurrentStore = defineStore({
    id: "current",
    state: () => ({
        step: 1, // Aktualny krok "kreatora" filtrów/widoku
        vehicles: [], // Lista aktualnych pojazdów (odświeżana cyklicznie)
        vehiclesIntervalTimes: [], // Interwały do walidacji czasu pojazdów (do kasowania po odświeżeniu)
        intervalFetch: undefined, // Interval do fetchowania danych
        intervalCheck: undefined, // Interval do sprawdzania stanu pojazdów
        queryCount: 0, // Licznik zapytań do API (np. do nowych pojazdów)
    }),
    actions: {
        // Czyści i resetuje wszystko przy wylogowaniu/zmianie widoku
        stopLogout() {
            this.stopIntervals();
            this.setStepValue(1);
            this.setVehicles([])
        },

        // Zwraca aktualny interval fetchujący pojazdy
        getIntervalFetch() {
            return this.intervalFetch;
        },
        // Ustawia interval fetchujący pojazdy
        startIntervalFetch(functionSet) {
            this.intervalFetch = functionSet;
        },
        // Usuwa interval fetchujący pojazdy
        stopIntervalFetch() {
            clearInterval(this.intervalFetch);
            this.intervalFetch = undefined;
        },

        // Zwraca aktualny interval sprawdzający pojazdy
        getIntervalCheck() {
            return this.intervalCheck;
        },
        // Ustawia interval sprawdzający pojazdy
        startIntervalCheck(functionSet) {
            this.intervalCheck = functionSet;
        },
        // Usuwa interval sprawdzający pojazdy
        stopIntervalCheck() {
            clearInterval(this.intervalCheck);
            this.intervalCheck = undefined;
        },

        // Usuwa oba interwały i kasuje interwały dla pojedynczych pojazdów
        stopIntervals() {
            this.stopIntervalCheck();
            this.stopIntervalFetch();
            this.clearVehicleIntervals();
        },

        // Ustawia aktualny krok widoku
        setStepValue(value) {
            this.step = value;
        },

        // Sprawdza, czy dany pojazd powinien nadal być widoczny na liście (czy jego checkpointTime już minął)
        checkVehicleDate: function (veh, momentDiffServer) {
            let vehicleTime = moment(veh.checkpointTime).add(momentDiffServer, "milliseconds");
            let currentTime = moment();
            if (vehicleTime.isBefore(currentTime)) {
                // Jeśli czas pojazdu już minął, usuwa go z listy
                this.vehicles = this.vehicles.filter(vehicle => 
                    moment(vehicle.checkpointTime).add(momentDiffServer, "milliseconds").isAfter(currentTime)
                );
                this.setVehicles(this.vehicles, momentDiffServer);
            }
        },              
        // Dla każdego pojazdu ustawia osobny interwał sprawdzający, czy czas pojazdu minął
        startVehicleIntervals: function (momentDiffServer) {
            this.vehicles.forEach(veh => {
                this.vehiclesIntervalTimes.push(setInterval(() => {
                    this.checkVehicleDate(veh, momentDiffServer);
                }, 500));
            })
        },
        // Czyści wszystkie interwały sprawdzające czas pojazdów
        clearVehicleIntervals: function () {
            this.vehiclesIntervalTimes.forEach(int => {
                clearInterval(int);
            })
            this.vehiclesIntervalTimes = [];
        },
        // Ustawia listę pojazdów oraz restartuje ich interwały sprawdzające czas
        setVehicles(value, momentDiffServer) {
            this.clearVehicleIntervals();
            this.vehicles = value;
            this.startVehicleIntervals(momentDiffServer);
        },

        // Przechodzi do kolejnego kroku kreatora (np. filtrów)
        nextStep() {
            if (this.step < 3) {
                this.step++;
            }
            if (this.step === 3) {
                // Przed przejściem do kroku 3 sprawdza, czy wypełniono wymagane dane
                const filtersStore = useCurrentFiltersStore();
                filtersStore.checkRequireData();
                if (filtersStore.error) {
                    this.step = 1; // Jeśli brakuje wymaganych danych, wraca do kroku 1
                }
            }
            return this.step;
        },
        // Cofanie się do poprzedniego kroku
        previousStep() {
            if (this.step > 1) {
                this.step--;
            }
            return this.step;
        },

        // Resetowanie licznika zapytań (np. na starcie widoku)
        resetQueryCount() {
            this.queryCount = 0;
        },
        // Zwiększanie licznika zapytań (np. po wykryciu nowych pojazdów)
        incrementQueryCount() {
            this.queryCount++;
        },
    },
});

// Hot module reload (tylko development)
if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(useCurrentStore, import.meta.hot));
}
